import React, { useEffect } from "react";
import { Pagination  } from 'antd';
import { connect } from "react-redux";
import { 
    getTrainingClassParticipantList,
} from "../../../../../redux/trainingclass/trainingClassState";
import Card from "components/card";
import PopupButton from "components/button/PopupButton";
import TrainingClassParticipantForm from "./TrainingClassParticipantForm";
import { User } from "lucide-react";
import TrainingModuleParticipantCard from "./TrainingClassParticipantCard";
import SearchFilter from "components/search/SearchFilter";


const TrainingClassParticipantTable = ({ 
    recordList, 
    pagination, 
    doSearch, 
    filters, 
    classeId 
}) => {
    
    useEffect(() => {
        if (classeId) {
            doSearch({paginate: pagination.per_page, classeId});
        } 
    }, [doSearch, classeId, pagination]);

    return (  

        <Card className="bg-white flex flex-col gap-6 rounded-2xl border-2 border-slate-200 dark-mode-card">
			<div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6">
				<div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
					<div>
						<h4 className="text-[16px] leading-none title-text">
							Participants
						</h4>
                        <p className="text-[13px] muted-text">
							View and manage all participants enrolled in this course.
						</p>
					</div>
					<div className="flex items-center gap-2">
                        <div className="flex-1 min-w-0 sm:w-[400px]">
                            <SearchFilter placeholder="Search by name..." searchHandler={doSearch} filters={filters} pagination={pagination}/>
                        </div>
                        <PopupButton 
                            id="add_class_participants" 
                            title="Add Course Participants" 
                            label="Add" 
                            btnClass="btn-small" 
                            modalWidth={500}
                            useCustomClass={true}
                        >
                            <TrainingClassParticipantForm recordId={0} mode="edit" classeId={classeId} />
                        </PopupButton>
                    </div>
				</div>
			</div>
			<div className="px-6 pb-6">
				<div className="space-y-4">
					{recordList && recordList.length > 0 ? (
                        recordList.map((class_participant) => 
                            <TrainingModuleParticipantCard 
                                key={class_participant.tcp_id}
                                recordData={class_participant}
                                classeId={classeId}
                            />)
                        )   :   (
                        <div className="text-center py-12 muted-text">
                            <User className="w-12 h-12 mx-auto mb-4"/>
                            <p>No team member found matching the filters</p>
                        </div>
					)}
				</div>
				<div className="flex justify-end py-4">
					<Pagination
						current={pagination.current_page}
						pageSize={pagination.per_page}
						total={pagination.total}
						showSizeChanger={false}
						onChange={(page) =>
                            doSearch({
                                ...filters,
                                page,
                                paginate: pagination.per_page,
                            })
						}
					/>
				</div>
			</div>
		</Card>
    );
};

const mapStateToProps = (state) => ({
  recordList: state.trainingClass.trainingClassParticipantList?.items,
  pagination: state.trainingClass.trainingClassParticipantList?.pagination,
  filters: state.trainingClass.trainingClassParticipantList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTrainingClassParticipantList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassParticipantTable);
